






























































































import { Component, Vue } from "vue-property-decorator";

import axios from "axios";
import firebase from "firebase";
// import * as googleMaps from "@google/maps";
// import {} from "@types/googlemaps";

@Component({
  components: {},
})
export default class LoginPage extends Vue {
  showModal = false;
  public phoneNumber = "";
  public Code = "";
  public appVerifier: any;
  isSignIn = false;
  userName = "User Name";
  userProfile: object;
  address = "";
  address1 = "";
  email: string = "";
  imageUrl: string;
  RegisteredEmail = [];
  clickHandle() {
    this.showModal = !this.showModal;
  }

  constructor() {
    super();
    this.initCaptcha();
  }
  UserCoordinate = {
    lat: 0,
    long: 0,
  };

  initCaptcha() {
    setTimeout(() => {
      (window as any).recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        "recaptcha-container",
        {
          size: "normal",
          callback: function (response: any) {
            console.log("Complete");
          },
          "expired-callback": function () {
            console.log("Expired");
          },
        }
      );
      this.appVerifier = (window as any).recaptchaVerifier;
      (window as any).recaptchaVerifier.render().then(function (widgetId: any) {
        (window as any).recaptchaWidgetId = widgetId;
      });
    }, 1000);
  }

  async mounted() {
    // load  google plugin
    // new google.maps.Map(document.getElementById("autoComplete"));
    import("@/plugins/google-oauth2").then(async () => {
      while (!this.$gAuth.isInit) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    });
    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/core/CoreService/GetPermittedUserList",
      {}
    );
    this.RegisteredEmail = response.data.emailList;
    // console.warn("email", response.data.emailList);
  }
  //

  async phoneLogin() {
    // Start Firebase invisible reCAPTCHA verifier
    try {
      const result = await firebase
        .auth()
        .signInWithPhoneNumber(this.phoneNumber, this.appVerifier)
        .then((confirmationResult) => {
          // At this point SMS is sent. Ask user for code.
          const code = window.prompt("Please enter the 6 digit code");
          return confirmationResult.confirm(code);
        })
        .then((result) => {
          // User is now signed in and accessible via result.user.
          console.log(result);
        });
      console.log(result);
    } catch (error) {
      console.log(error);
      (window as any).grecaptcha.reset((window as any).recaptchaWidgetId);
    }

    // console.log(result);
  }

  reset() {
    this.phoneNumber = "";
    (window as any).grecaptcha.reset((window as any).recaptchaWidgetId);
  }

  async gmailLogin() {
    const gUser = await this.$gAuth.signIn();
    const idToken = gUser.getAuthResponse().id_token;

    this.userProfile = gUser.getBasicProfile();
    this.isSignIn = this.$gAuth.isAuthorized;
    // this.$store.commit("setAuthentication", true);

    localStorage.setItem("UserLoggedIn", "true");
    console.log("user login ", localStorage.getItem("UserLoggedIn"));
    this.$store.commit("setAuthentication", true);
    console.log(idToken);
    console.log(this.userProfile);

    this.userName = gUser.getBasicProfile().getGivenName();
    this.email = gUser.getBasicProfile().getEmail();
    // const checkEmail = this.RegisteredEmail.filter(function (elem) {
    //   if (elem == gUser.getBasicProfile().getEmail()) return elem;
    // });
    const checkRegistered = this.RegisteredEmail.includes(gUser.getBasicProfile().getEmail());
    if (checkRegistered) {
      localStorage.setItem("UserLoggedIn", "true");
      localStorage.setItem("profileImageUrl", gUser.getBasicProfile().getImageUrl());
      this.$router.push({ path: "/dashboard" });
    } else {
      window.alert("Sorry! " + gUser.getBasicProfile().getEmail() + " is not registered email");
      this.SignOut();
      location.reload();
    }
    console.log("email ");

    // this.$router.push({ path: "/dashboard" });
    // console.log(gUser.getBasicProfile());
  }
  async SignOut() {
    await this.$gAuth.signOut();
    this.isSignIn = false;
  }
  // created() {
  //   localStorage.setItem("UserLoggedIn", "true");
  //   this.$router.push({ path: "/dashboard" });
  // }
}
